import { useMemo, useCallback } from 'react';
import { useApi } from '../../provider';
import { useQuery } from '../../hooks';
import { AuditService } from './service';
import { AuditLogQueryParams, AuditLogQueryResponse } from './types';

const CACHE_KEY = 'audit';

export function useAuditLogs(params?: AuditLogQueryParams) {
  const api = useApi();
  const service = useMemo(() => new AuditService(api), [api]);
  const fetcher = useCallback(() => service.getAll(params), [service, params]);

  return useQuery<AuditLogQueryResponse>(CACHE_KEY, fetcher);
}

// Convenience hook that provides audit logs with common utilities
export function useAuditLogsPage(params?: AuditLogQueryParams) {
  const auditResponse = useAuditLogs(params);

  return useMemo(
    () => ({
      // Query operations
      auditLogs: auditResponse,

      // Convenience getters for common states
      data:
        auditResponse.status === 'success'
          ? (auditResponse.data.auditLogs ?? [])
          : [],
      total:
        auditResponse.status === 'success'
          ? (auditResponse.data?.total ?? 0)
          : 0,
      isLoading: auditResponse.status === 'loading',
      isError: auditResponse.status === 'error',
      error: auditResponse.status === 'error' ? auditResponse.error : null,

      // Actions
      refetch: auditResponse.refetch,
      invalidate: auditResponse.invalidate,
    }),
    [auditResponse]
  );
}
